import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/solar-calculator/page.tsx");
